// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"660":"3e9b2d2a","790":"c167b344"}[chunkId] + ".chunk.css";
};